import { CurrencyIcon } from 'src/modules/currencies/components/CurrencyIcon';
import { useCurrencyList } from 'src/modules/currencies/hooks/useCurrencies';

import { FormikSelect } from '@/components/forms';
import { SelectItem } from '@/design-system/components/ui';

interface Props {
  inputName: 'currencyVolumeArgument' | 'currencyRevenueArgument';
  chainId: number;
}

export default function SelectTokenForCurrencyArgument({ inputName, chainId }: Props) {
  const { currencies } = useCurrencyList({ chainIdentifier: String(chainId), priceReference: true }, !!chainId);

  return (
    <FormikSelect name={`${inputName}.value`} label="Token">
      {currencies.map(({ logoUri, name, address, decimals }) => (
        <SelectItem value={address} key={name}>
          <div className="tw:flex tw:items-center tw:gap-2">
            <CurrencyIcon logoUri={logoUri} name={name} size={20} />
            <span className="tw:capitalize">
              {name} <span className="tw:text-sm tw:text-muted-foreground">{decimals} decimals</span>
            </span>
          </div>
        </SelectItem>
      ))}
    </FormikSelect>
  );
}
